import { resolveDirective as _resolveDirective, withDirectives as _withDirectives, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
const _hoisted_1 = ["data-maska"];
export function render(_ctx, _cache, $props, $setup, $data, $options) {
    const _directive_maska = _resolveDirective("maska");
    return _withDirectives((_openBlock(), _createElementBlock("input", {
        ref: "inputRef",
        type: "text",
        class: "form-control",
        "data-maska": typeof $props.mask !== 'string' ? JSON.stringify($props.mask) : $props.mask,
        onMaska: _cache[0] || (_cache[0] =
            //@ts-ignore
            (...args) => ($setup.onMaska && $setup.onMaska(...args)))
    }, null, 40, _hoisted_1)), [
        [_directive_maska]
    ]);
}
